import { useEffect } from 'react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

import { useTimerStore } from 'store/timer';

dayjs.extend(duration);

const interval = 1000;
let timerId: number;

function getPaddedTime(value: number = 0) {
    return `${value}`.padStart(2, '0');
}

export function useTimer() {
    const { elapsedTime, setElapsedTime } = useTimerStore();

    useEffect(() => {
        timerId = window.setInterval(() => {
            setElapsedTime(time => (time ?? 0) + interval);
        }, interval);

        return () => {
            window.clearInterval(timerId);
        };
    }, []);

    const time = dayjs.duration(elapsedTime ?? 0);
    // не можем использовать format с duration https://github.com/iamkun/dayjs/issues/1757
    const timeString = [time.get('hours'), time.get('minutes'), time.get('seconds')].map(getPaddedTime).join(':');

    return timeString;
}
